import * as React from "react";
import { CSSProperties, PropsWithChildren, ReactNode } from "react";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BaseCardProps } from "./BaseCardProps";

export const LeftSideCard = styled.div<BaseCardProps>`
  background-color: #fff;
  padding: 0.75rem;
  margin: 0.25rem 0.25rem 0.5rem 0.25rem;
  width: 250px;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border-left: 6px #fff solid;
  ${(props) => {
    if (props.$isFinished && !props.$isSelected) {
      return "border-left-color: lightgreen;";
    }
    if (props.$isSelected) {
      return "border-left-color: #FFCC00;";
    }

    return "";
  }}
  ${(props) => {
    if (props.$isFinished) {
      return "background: lightgreen;";
    }
    if (props.$isSelected) {
      return "background: #FFCC00;";
    }

    return "";
  }}
  ${(props) => (props.$isSelectable ? "cursor: pointer;" : "")}
`;

export const LeftSideIcon = styled(FontAwesomeIcon)<BaseCardProps>`
  margin-right: 0.5rem;
  color: lightgray;
  ${(props) => (props.$isFinished ? "color: #000000E6;" : "")}
`;

type LeftSideLeftGapSpanProps = {
  style?: CSSProperties;
  children?: ReactNode;
};
export const LeftSideLeftGapSpan = styled.span<LeftSideLeftGapSpanProps>`
  margin-left: 20px;
`;

export default function BaseCard({
  children,
  onClick,
  $isSelected = true,
  $isFinished,
  $isSelectable = false,
  $hasDeleteButton = true,
}: PropsWithChildren<BaseCardProps>) {
  return (
    <LeftSideCard
      onClick={onClick}
      $isSelected={$isSelected}
      $isFinished={$isFinished}
      $isSelectable={$isSelectable}
      $hasDeleteButton={$hasDeleteButton}
    >
      <LeftSideIcon
        icon={faGripVertical}
        $isSelected={$isSelected}
        $isFinished={$isFinished}
        $isSelectable={$isSelectable}
        $hasDeleteButton={$hasDeleteButton}
        style={{ visibility: $hasDeleteButton ? "visible" : "hidden" }}
      />
      {children}
    </LeftSideCard>
  );
}
